module.exports = __webpack_public_path__ + "static/img/page top img_clear_desktop.e7ca1eb9.jpg";